import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableRecaptchaUserLogin',
  initialState: false,
  reducers: {
    setEnableRecaptchaUserLogin(_, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableRecaptchaUserLogin } = slice.actions;
export default slice.reducer;
